import { render } from "./ServerMonitor.vue?vue&type=template&id=247bbfce&scoped=true"
import script from "./ServerMonitor.vue?vue&type=script&lang=js"
export * from "./ServerMonitor.vue?vue&type=script&lang=js"

import "./ServerMonitor.vue?vue&type=style&index=0&id=247bbfce&scoped=true&lang=scss"

import exportComponent from "/home/xpixel/htdocs/xpixel.ru/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247bbfce"]])

export default __exports__